// import RefundedIcon from "./RefundedIcon";
//extract phoneNumber without country code
// export const extractPhoneNumber = (countryCode, phoneNumber) => {
//     if (phoneNumber?.startsWith(countryCode)) {
//         return phoneNumber?.slice(countryCode.length);
//     }
//     return phoneNumber;
// };
import klarna from "../assets/images/Klarna.png";
import applePay from "../assets/images/ApplePay.png";
import googlePay from "../assets/images/GooglePay.png";
import IconVisa from "../assets/images/icon-visa.png";
import * as Library from "./Library";
import momentTimeZone from "moment-timezone";

export const extractPhoneNumber = (countryCode, phoneNumber) => {
    const formattedCountryCode = countryCode ? countryCode : phoneNumber ? phoneNumber.split(" ")[0] : "";
    if (!phoneNumber || !formattedCountryCode) {
        return null; // or return an empty string, depending on your requirements
    }

    let formattedPhoneNumber = phoneNumber.replace(/[^\d]+/g, ""); // remove white spaces
    if (formattedPhoneNumber.startsWith(countryCode)) {
        formattedPhoneNumber = formattedPhoneNumber.slice(formattedCountryCode.length);
    } else {
        formattedPhoneNumber = formattedPhoneNumber.replace(formattedCountryCode, ""); // remove country code
    }
    return formattedPhoneNumber;
};

//function to format phone number with pattern mainly used for saving formatted numbers in onboarding, accountPanel and paymentPopup

export const phoneNumberPattern = (number, pattern) => {
    number = number?.replace(/\D/g, "");

    const formattedNumber = [];
    let numberIndex = 0;

    for (let i = 0; i < pattern?.length; i++) {
        if (pattern?.[i] === ".") {
            if (numberIndex < number?.length) {
                formattedNumber.push(number?.[numberIndex]);
                numberIndex++;
            }
        } else {
            formattedNumber?.push(pattern?.[i]);
        }
    }

    return formattedNumber?.join("");
};
// Function to save the location object to localStorage
export const saveLocation = location => {
    const locationObject = { location };
    localStorage.setItem("userLocation", JSON.stringify(locationObject));
};

// Function to retrieve the location object from localStorage
export const getLocation = () => {
    const locationString = localStorage.getItem("userLocation");
    if (locationString) {
        return JSON.parse(locationString)?.location;
    }
    return null;
};
// Function to save the location object to localStorage
export const saveCoordinates = coords => {
    const coordsObject = { coords };
    localStorage.setItem("userCoords", JSON.stringify(coordsObject));
};

// Function to retrieve the location object from localStorage
export const getCoordinates = () => {
    const coordsString = localStorage.getItem("userCoords");
    if (coordsString) {
        return JSON.parse(coordsString)?.coords;
    }
    return null;
};

const setCookie = (name, value, hours) => {
    const date = new Date();
    date.setTime(date.getTime() + hours * 60 * 60 * 1000); // changed to hours
    // date.setTime(date.getTime() + hours * 1000); // Changed to 10 seconds
    const expires = `expires=${date.toUTCString()}`;
    document.cookie = `${name}=${value};${expires};path=/`;
};
export const getCookie = name => {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};

const imageExists = (array, ourID) => {
    return array.some(item => item.ourID === ourID);
};

export const storeImageDetails = (ourID, timestamp) => {
    const storedData = JSON.parse(getCookie("recentlyViewedImages")) || [];

    if (!imageExists(storedData, ourID)) {
        const newImageDetails = { ourID, timestamp };

        storedData.push(newImageDetails);

        setCookie("recentlyViewedImages", JSON.stringify(storedData), 48); // Set cookie for 48 hours
    }
};

//checking phone operating system

export const getMobileOperatingSystem = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
};
export const paymentMethods = {
    APPLE_PAY: "APPLE_PAY",
    GOOGLE_PAY: "GOOGLE_PAY",
    KLARNA_PAY: "KLARNA_PAY",
    CARD: "CARD",
    PAYPAL: "PAYPAL",
    IDEAL: "IDEAL",
    MOBILE_PAY: "MOBILE_PAY",
    SWISH: "SWISH",
    REVOLUT: "REVOLUT"
};
export const paymentTypeNames = {
    APPLE_PAY: "Apple Pay",
    GOOGLE_PAY: "Google Pay",
    KLARNA_PAY: "Klarna",
    CARD: "Card",
    PAYPAL: "PayPal",
    IDEAL: "iDEAL",
    MOBILE_PAY: "MobilePay",
    SWISH: "Swish",
    REVOLUT: "Revolut"
};
export const cardType = {
    VISA: "visa",
    MASTERCARD: "mastercard",
    KLARNA_PAY: "klarna pay",
    APPLE_PAY: "apple pay",
    GOOGLE_PAY: "google pay",
    PAYPAL: "paypal",
    IDEAL: "ideal",
    MOBILE_PAY: "mobile pay",
    SWISH: "swish",
    REVOLUT: "revolut"
};

export const processPaymentData = async ({ responseData }) => {
    const cardsData = await responseData?.data?.data?.data?.cards;
    const defaultPaymentMethod = await responseData?.data?.data?.data?.defaultPaymentMethod;
    return {
        cardsData,
        defaultPaymentMethod
    };
};

export const handleDefaultPaymentMethod = ({ defaultPaymentMethod }) => {
    const data = {
        imgSource: null,
        type: ""
    };
    if (defaultPaymentMethod === paymentMethods?.CARD) {
        data.imgSource = IconVisa;
        data.type = paymentTypeNames?.CARD;
    } else if (defaultPaymentMethod === paymentMethods?.KLARNA_PAY) {
        data.imgSource = klarna;
        data.type = paymentTypeNames?.KLARNA_PAY;
    } else if (defaultPaymentMethod === paymentMethods?.APPLE_PAY) {
        data.imgSource = applePay;
        data.type = paymentTypeNames?.APPLE_PAY;
    } else if (defaultPaymentMethod === paymentMethods?.GOOGLE_PAY) {
        data.imgSource = googlePay;
        data.type = paymentTypeNames?.GOOGLE_PAY;
    }
    return data;
};

export const getUserPaymentMethods = async ({ email }) => {
    const data = {
        paymentData: {}
    };
    try {
        const res = await Library.makePostRequest(
            "getUserPaymentMethods",
            {
                email
            },
            false,
            false
        );
        data.paymentData = await processPaymentData({ responseData: res });

        return data;
    } catch (error) {
        return data;
    }
};

export const formatOpeningHours = openingHours => {
    return Object.entries(openingHours)
        ?.filter(([key]) => key.toLowerCase() !== "weekdays")
        ?.map(([day, details]) => {
            const { hourStart, hourEnd, closedAllDay } = details;
            if (closedAllDay || (!hourStart && !hourEnd)) {
                return { day, time: "Closed" };
            }
            return { day, time: `${hourStart} - ${hourEnd}` };
        });
};

export const isStoreOpen = ({ storeInformation }) => {
    const data = {
        isOpen: false
    };
    const dayOfWeek = new Date().toLocaleString("en-us", { weekday: "long" }).toLowerCase();
    const openHours = storeInformation?.openHours?.[dayOfWeek];

    if (!openHours || openHours.closedAllDay) return false;
    if (openHours.openAllDay) return true;

    const currentTime = momentTimeZone.tz("Europe/Oslo").format("HH:mm");
    const hourStart = openHours?.hourStart;
    const hourEnd = openHours?.hourEnd;
    data.isOpen = currentTime >= hourStart && currentTime <= hourEnd;
    return data;
};
